import { COLORS } from '@/theme';
import styled from 'styled-components';
import { ImportStatusEnum } from '@/models/productsImport.model';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
`;

export const StyledBadgeWrapper = styled.div`
  width: 8.5rem;
`;

export const StyledBadge = styled.div<{ $status?: ImportStatusEnum }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0.25rem 0.75rem;
  height: 1.5rem;
  gap: 0.5rem;
  border-radius: 1.6rem;
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  background: ${COLORS.GRAY};

  .indicator {
    border-radius: 50%;
    height: 0.75rem;
    width: 0.75rem;
    background: ${({ $status }) => {
      switch ($status) {
        case ImportStatusEnum.FAILED:
          return COLORS.RED;
        case ImportStatusEnum.PROCESSING:
          return COLORS.ORANGE;
        case ImportStatusEnum.FINISHED:
          return COLORS.GREEN;
      }
    }};
  }
`;

export const StyledDownloadButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  border-radius: 0.25rem;
  padding: 0.25rem 0.75rem !important;
  height: 2.75rem;
  gap: 0.5rem;
  color: ${COLORS.BLACK} !important;
  background: ${COLORS.LIGHT_GRAY_2};
  border: 1px solid ${COLORS.BLACK} !important;

  &:hover {
    color: ${COLORS.BLACK};
  }
`;
